/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../../Pages/AdminScreens/EmployeeProfile/EmployeeProfile.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import {
  Modal,
} from "react-bootstrap";
import profileimg from "../../../Assets/Images/profileimg.png";
import { FaPhoneAlt } from "react-icons/fa";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";
import { useLocation } from "react-router-dom";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";

const EmployeeProfile = () => {
  const LoginToken = GetToken();
  const location = useLocation();
  const comingData = location.state;
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [EmpData, setEmpData] = useState("");

  const GetProfile = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setEmpData(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    GetProfile();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => setShowSidebar(false), 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const MaritalStatusOptions = [
    { value: "Single", label: "Single", id: 0 },
    { value: "Married", label: "Married", id: 1 },
    { value: "Divorced", label: "Divorced", id: 2 },
    { value: "Widowed", label: "Widowed", id: 3 },
  ];

  const maritalStatus = comingData?.MaritalStatus ?? EmpData?.MaritalStatus;
  const maritalLabel =
    MaritalStatusOptions.find((s) => s.id === maritalStatus)?.value || "-";

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page-profile"
              : "main-container-of-all-employees-page-profile-new"
          }
        >
          {/* Page Header */}
          <div className="inner-container-of-all-employees-page">
            <div className="header-of-employees-page row">
              <div className="all-employee-text-profile col">
                <h4>Profile</h4>
              </div>

              <div className="all-employees-directory-profile col">
                <div className="home-icon-header-profile">
                  <BiHomeAlt className="home-icon-header-inn-profile" />
                </div>
                <div className="arrow-icon-header-profile">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-header-profile">
                  <p>Employees</p>
                </div>
                <div className="arrow-icon-header-profile">
                  <MdKeyboardArrowRight />
                </div>
                <div className="all-employee-text-header-profile">
                  <p>Profile</p>
                </div>
              </div>
            </div>
          </div>

          {/* Profile Body */}
          <div className="profile-body-wrapper">
            <div className="profile-layout">
              {/* LEFT CARD */}
              <div className="profile-left-card">
                <div className="profile-dark-banner">
                  <p className="dr-john-smith">
                    {comingData?.FirstName || EmpData?.FirstName || "-"}
                  </p>
                </div>

                <div className="profile-image-wrapper">
                  <img
                    src={comingData?.UrlLink || EmpData?.UrlLink || profileimg}
                    alt="Profile"
                    className="profileimage-class"
                    onError={(e) => (e.target.src = profileimg)}
                  />
                </div>

                <div className="profile-left-lower">
                  <p className="senior-empolyee-details">
                    {comingData?.Address || EmpData?.Address || "-"}
                  </p>

                  <span className="phone-icon-and-number">
                    <FaPhoneAlt />
                    <p>{comingData?.Mobile || EmpData?.Mobile || "-"}</p>
                  </span>
                </div>
              </div>

              {/* RIGHT ABOUT */}
              <div className="profile-right-info">
                <h3 className="ueryr">About me</h3>

                <div className="profile-info-grid">
                  <div className="profile-info-item">
                    <strong>Full Name</strong>
                    <p>
                      {comingData?.FirstName || EmpData?.FirstName || "-"}{" "}
                      {comingData?.LastName || EmpData?.LastName || ""}
                    </p>
                  </div>

                  <div className="profile-info-item">
                    <strong>Mobile</strong>
                    <p>{comingData?.Mobile || EmpData?.Mobile || "-"}</p>
                  </div>

                  <div className="profile-info-item">
                    <strong>Email</strong>
                    <p className="profile-info-wrap">
                      {comingData?.Email || EmpData?.Email || "-"}
                    </p>
                  </div>

                  <div className="profile-info-item">
                    <strong>Location</strong>
                    <p className="profile-info-wrap">
                      {comingData?.Address || EmpData?.Address || "-"}
                    </p>
                  </div>

                  <div className="profile-info-item">
                    <strong>Marital Status</strong>
                    <p>{maritalLabel}</p>
                  </div>

                  <div className="profile-info-item">
                    <strong>Role</strong>
                    <p>
                      {comingData?.Positions?.RoleName ||
                        EmpData?.Positions?.RoleName ||
                        "-"}
                    </p>
                  </div>

                  {(comingData?.Positions?.RoleName ||
                    EmpData?.Positions?.RoleName) !== "Admin" && (
                    <>
                      <div className="profile-info-item">
                        <strong>Department</strong>
                        <p>
                          {comingData?.Departments?.Name ||
                            EmpData?.Departments?.Name ||
                            "-"}
                        </p>
                      </div>

                      <div className="profile-info-item">
                        <strong>Designation</strong>
                        <p>
                          {comingData?.Designations?.DesignationName ||
                            EmpData?.Designations?.DesignationName ||
                            "-"}
                        </p>
                      </div>
                    </>
                  )}
                </div>

                <div className="profile-education-section">
                  <h2 className="profile-section-heading">Education</h2>
                  <p>{comingData?.Education || EmpData?.Education || "-"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal>
    </>
  );
};

export default EmployeeProfile;